const resources = {
    giftFinder: 'Gift Finder',
    newChat: 'New chat'
};

export default function getResource(label) {
    return resources[label];
}
